import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';

import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import UserForm from '../components/UserForm';
import {
  requestUsersTypeahead,
  requestUser,
  updateUser,
  createUser
} from '../../../store/users/UsersActions';
import { requestRoles } from '../../../store/roles/RolesActions';
import { requestOrganizations } from '../../../store/organizations/OrganizationsActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import { requestLocationsByTenantId } from '../../../store/locations/LocationsActions';
import { hostTitle } from '../../../config/ui';

class UserEdit extends React.Component {
  componentWillMount() {
    const {
      getUser,
      params,
      roles,
      getRoles,
      organizations,
      getOrganizations,
    } = this.props;

    getUser(params.id);

    if (isEmpty(roles.data)) {
      getRoles();
    }
    if (isEmpty(organizations.data)) {
      getOrganizations();
    }
  }

  onSubmit = (values) => {
    if (values.clients && values.clients.length > 0 && values.clients[0].code === '') {
      values.clients = '';
    }
    if (this.props.params.mode === 'Add') {
      this.props.createUser(values).then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('User has been saved.');
          hashHistory.push('/user-management/');
        }
      });
    }
    else {
      this.props.updateUser(values).then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('User has been saved.');
          hashHistory.push('/user-management/');
        }
      });
    }
  };

  onCancel = () => {
    hashHistory.push('/user-management/');
  };

  searchClients = (tenantId, search) => {
    return this.props
      .clientsTypeahead({
        tenantId: tenantId ? tenantId : this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  searchClinics = (tenantId) => {
    return this.props
      .getLocations({
        tenantId: tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push(item),
          );
        }
        return options;
      });
  };

  searchUsers = (search, filters = '', orgId) => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 10,
        order: '',
        search,
        filters,
        tenantId: orgId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) =>
            options.push({
              id: item.id,
              name: `${item.firstName} ${item.lastName} (${item.email})`,
            }),
          );
        }
        return options;
      });
  };

  initialValues = () => {
    const values = { ...this.props.users.user };

    if (!values.organizationID) {
      values.organizationID = '';
    }
    if (!values.clients) {
      values.clients = [];
    }
    if (!values.supervised) {
      values.supervised = [];
    }
    if (!values.supervisers) {
      values.supervisers = [];
    }
    values.users = [];
    return values;
  };

  render() {
    const {
      users: { user, isLoading },
      roles,
      organizations,
      clinics,
    } = this.props;

    const orgOptions = organizations.data.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    orgOptions.push({ value: '', label: 'None' });

    const clinicOptions = clinics.map((item) => ({
      value: item.id,
      label: item.name,
    }));
    return (
      <div id="content">
        {user && (
          <Helmet title={`${(user.firstName === undefined) ? 'New' : user.firstName} ${(user.lastName === undefined) ? 'User' : user.lastName} – ${hostTitle()}`} />
        )}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'User Management', route: '/user-management' },
            'User',
          ]}
          icon="fa fa-fw fa-users"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>
                Edit User{' '}
                {user && (
                  <i>
                    {user.firstName} {user.lastName} ({user.id})
                  </i>
                )}
              </h2>
            </header>
            <div>
              <div className="widget-body">
                {!roles.isLoading && roles.data && (
                  <UserForm
                    roles={roles.data}
                    onSubmit={this.onSubmit}
                    onCancel={this.onCancel}
                    organizationsList={orgOptions}
                    searchClients={this.searchClients}
                    searchClinics={this.searchClinics}
                    searchUsers={this.searchUsers}
                    clinicsList={clinicOptions}
                    isLoading={isLoading}
                    initialValues={this.initialValues()}
                    mode={this.props.params.mode}
                  />
                )}
                {(roles.isLoading || isLoading) && (
                  <div className="spinner hide" />
                )}
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    users: state.users,
    roles: state.roles,
    organizations: state.organizations,
    clients: state.clientmanager,
    clinics: state.locations.data,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
    getUser: (id) => dispatch(requestUser(id)),
    getRoles: () => dispatch(requestRoles()),
    getOrganizations: () => dispatch(requestOrganizations()),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    createUser: (user) => dispatch(createUser(user)),
    updateUser: (user) => dispatch(updateUser(user)),
    getLocations: (params) => dispatch(requestLocationsByTenantId(params)),
  }),
)(UserEdit);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/UserEdit.js